import * as React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { ProjectModuleMetaFieldProps } from "../interface";

const useStyles = makeStyles({
    searchable: {
        marginTop: "10px",
    },
});

const ProjectModuleMetaField = ({
    optionsSelectedHandler,
    featuresMetaData,
}: ProjectModuleMetaFieldProps) => {
    const classes = useStyles();
    const rolesOptions = React.useMemo(
        () => [
            "Administrator",
            "Dispatcher",
            "Helper",
            "Service Manager",
            "Technician",
        ],
        []
    );

    return (
        <div style={{ display: "inline", marginLeft: "8px" }}>
            <div style={{ margin: "10px 10px" }}>
                <Autocomplete
                    className={classes.searchable}
                    id="job-costing-roles-select"
                    options={rolesOptions}
                    value={
                        featuresMetaData.PROJ_MODULE
                            ? featuresMetaData.PROJ_MODULE
                                  .allowedRolesForJobCosting
                            : []
                    }
                    multiple={true}
                    disableCloseOnSelect
                    onChange={(e: any, selectedOptions: any) => {
                        optionsSelectedHandler(selectedOptions);
                    }}
                    getOptionLabel={(option: any) => option}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label={"Job Costing roles select"}
                        />
                    )}
                />
            </div>
        </div>
    );
};

export default ProjectModuleMetaField;
